import { supabase } from "@/integrations/supabase/client";
import type { Json } from "@/integrations/supabase/types";

export type AuthAction = 'login' | 'signup' | 'logout' | 'password_reset' | 'login_failed' | 'oauth_login';

interface LogAuthEventParams {
  action: AuthAction;
  userId?: string | null;
  email?: string | null;
  fullName?: string | null;
  metadata?: Json;
}

/**
 * Enregistre un évènement d'authentification.
 *
 * L'écriture passe obligatoirement par l'Edge Function `log-auth-event` :
 * la table `user_auth_logs` n'est plus inscriptible depuis le navigateur, ce qui
 * empêche la fabrication de fausses lignes d'audit. L'identité et l'adresse IP
 * sont déterminées côté serveur.
 */
export const logAuthEvent = async ({
  action,
  email,
  fullName,
  metadata
}: LogAuthEventParams): Promise<void> => {
  try {
    const { error } = await supabase.functions.invoke('log-auth-event', {
      body: {
        action,
        email: email || null,
        fullName: fullName || null,
        metadata: metadata ?? null
      }
    });

    if (error) {
      console.error("Erreur lors de l'enregistrement du log d'auth:", error);
    }
  } catch (error) {
    // Ne pas bloquer l'application si le log échoue
    console.error("Erreur lors de l'enregistrement du log d'auth:", error);
  }
};
